import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ProfileForm from "./ProfileForm";
import ChangePasswordForm from "./ChangePasswordForm";

const AccountSettings = () => {
  const [activeForm, setActiveForm] = useState("profile");

  const renderForm = () => {
    switch (activeForm) {
      case "profile":
        return <ProfileForm />;
      case "password":
        return <ChangePasswordForm />;
      default:
        return null;
    }
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }} // <-- En móviles, columna; en pantallas medianas en adelante, fila
      bgcolor="#fff"
      m={3}
      borderRadius={2}
      boxShadow={1}
    >
      {/* Sidebar */}
      <Box
        sx={{
          flex: { xs: "none", md: "0 0 25%" },
          borderRight: { xs: "none", md: "1px solid #eee" },
          borderBottom: { xs: "1px solid #eee", md: "none" },
          p: 2
        }}
      >
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Configuración de la cuenta
        </Typography>
        <List>
          <ListItem
            button
            selected={activeForm === "profile"}
            onClick={() => setActiveForm("profile")}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "#e3f2fd",
                borderLeft: { md: "4px solid #1976d2" },
                color: "#1976d2"
              },
              "&.Mui-selected:hover": {
                backgroundColor: "#d0e7fb"
              }
            }}
          >
            <ListItemIcon>
              <PersonIcon
                color={activeForm === "profile" ? "primary" : "inherit"}
              />
            </ListItemIcon>
            <ListItemText
              primary="Perfil del usuario"
              secondary="Configuración del perfil"
            />
          </ListItem>

          <ListItem
            button
            selected={activeForm === "password"}
            onClick={() => setActiveForm("password")}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "#e3f2fd",
                borderLeft: { md: "4px solid #1976d2" },
                color: "#1976d2"
              },
              "&.Mui-selected:hover": {
                backgroundColor: "#d0e7fb"
              }
            }}
          >
            <ListItemIcon>
              <VpnKeyIcon
                color={activeForm === "password" ? "primary" : "inherit"}
              />
            </ListItemIcon>
            <ListItemText
              primary="Cambiar contraseña"
              secondary="Actualizar la seguridad del perfil"
            />
          </ListItem>
        </List>
      </Box>

      {/* Main content */}
      <Box
        sx={{
          flex: 1,
          p: 3
        }}
      >
        {renderForm()}
      </Box>
    </Box>
  );
};

export default AccountSettings;
